import {
  NativeStackHeaderProps,
  Stack,
  useLocalSearchParams,
  useRouter,
} from 'expo-router';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { WebView } from 'react-native-webview';
import PdfViewer from 'shared/components/PdfRenderer/PdfViewer';
import Icon from 'shared/components/vxl/icon/Icon/Icon';
import ExpoNavigationBar from 'shared/components/vxl/navigation/ExpoNavigationBar/ExpoNavigationBar';
import theme from 'shared/styles/theme';
import { webViewAdditionalProps } from 'shared/utils/webView/webViewAdditionalProps';

const isPdfUrl = (url: string): boolean => {
  return url.split('?')[0].toLowerCase().endsWith('.pdf');
};

const ExternalDeeplinkScreen = () => {
  const { url } = useLocalSearchParams<{ url: string }>();
  const { bottom } = useSafeAreaInsets();
  const router = useRouter();

  const decodedUrl = url ? decodeURIComponent(url) : null;

  if (!decodedUrl) {
    return null;
  }

  return (
    <View style={[styles.container, { paddingBottom: bottom }]}>
      <Stack.Screen
        options={{
          headerShown: true,
          headerBackVisible: true,
          title: '',
          header: (props: NativeStackHeaderProps) => (
            <ExpoNavigationBar
              {...props}
              primaryIcon={<Icon iconKey="BACK" iconSize="MD" />}
              primaryOnPress={() => {
                if (router.canGoBack()) {
                  router.back();
                } else {
                  // Reached via cold-start — no back stack exists.
                  router.replace('/');
                }
              }}
            />
          ),
        }}
      />
      {isPdfUrl(decodedUrl) ? (
        <PdfViewer url={decodedUrl} />
      ) : (
        <WebView
          {...webViewAdditionalProps}
          source={{ uri: decodedUrl }}
          style={styles.webView}
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
  },
  webView: {
    flex: 1,
  },
});

export default ExternalDeeplinkScreen;
